import { CacheService } from '@statflo/cache';

// One and five year in ms - to be used for cache ttl
export const ONE_YEAR = 31556926000;
export const FIVE_YEARS = 157784630000;

export const HELP_CARDS_KEY = 'helpCardsSeen';

export const cache = new CacheService('STFLO_Conversations_Storage');

export default cache;



// WEBPACK FOOTER //
// ./src/services/CacheService.ts